import './liveTrackContent.css';
import DropDown from "../../../shared/drop-down/dropDown";
import LiveTrackVehicles from "../liveTrackVehicles/liveTrackVehicles";
import ReactMap from "../../../shared/map/map";

const LiveTrackContent = ({onRequestDVR}) => {
    return (
        <div className={'flex align-top live-track-content'}>
            <div className={'vehicle-trips-sec'}>
                <div className="round-corner-8">
                    <div className="section-title">Vehicles</div>
                    <div className="margin-b-20 ">
                        <DropDown classes={'trans-drop-down'} list={['Active', 'Inactive']} placeholder={'Filter'}/>
                    </div>
                    <div className="input-box margin-b-20">
                        <input type="text" placeholder={'Search'}/>
                    </div>
                    <LiveTrackVehicles/>
                </div>
            </div>

            <div className={'map-sec'}>
                <div className="section-title margin-b-20">Map</div>
                <div className={'live-track-map'}>
                    <ReactMap/>
                </div>
            </div>
        </div>
    )
}



export default LiveTrackContent;
